export default async function routeMonsterCartCompat() {
  if (!window.cartSettings?.enableMonsterCartRouteCompat) {
    return;
  }

  console.warn('[Route_MonsterCart_Compat] Compatibility mode is enabled');

  try {
    const [attrRes, itemRes] = await Promise.all([
      removeCartAttributes('route_toggle_state'),
      removeCartItem('routeins'),
    ]);

    console.log('[Route_MonsterCart_Compat] Attributes removed:', attrRes);
    console.log('[Route_MonsterCart_Compat] Item removed:', itemRes);

    window.location.reload();
  } catch (err) {
    console.error('[Route_MonsterCart_Compat] Error in routeController:', err);
  }
}
